// extracted by mini-css-extract-plugin
export var button_container = "styles-module--button_container--c8fb2";
export var card = "styles-module--card--fab0c";
export var card_inner = "styles-module--card_inner--43f51";
export var content_container = "styles-module--content_container--1b325";
export var hidden_content_container = "styles-module--hidden_content_container--932a0";
export var image_container = "styles-module--image_container--a376a";
export var is_open = "styles-module--is_open--19b82";